import './index_web.css';
import { View, Text } from '../../../component';
import { FaRegHandPointRight } from 'react-icons/fa';
import Constants from '.././../../constants';
import React from 'react';
import { Modal } from '@mui/material';

interface pointProps {
  title: any;
}

const Point = ({ title }: pointProps) => {
  const gameRuleTitle = { color: '#fff' };

  return (
    <View className={'YesNoRule__PointWrapper'}>
      <View className={'YesNoRule__PointIcon'}>
        <FaRegHandPointRight size={15} fill={'#fff'} />
      </View>
      <Text style={gameRuleTitle} className={'YesNoRule__PointTitle'}>{`${title}`}</Text>
    </View>
  );
};

interface Props {
  visible: any;
  onPressDismiss: any;
  language: any;
}

const YesNoRuleWeb = ({ visible, onPressDismiss, language = 'en' }: Props) => {
  const headerTitle = {
    color: '#fff'
  };
  const YesNoRule = Constants.YesNoRule;
  return (
    <Modal open={visible} onClose={onPressDismiss}>
      <View className={'YesNoRule__Container'}>
        <View style={{ padding: '10px 10px 0px 10px' }}>
          <Text style={headerTitle} className="YesNoRule__Title">
            {`${YesNoRule[1][language]}`}
          </Text>
          <View
            style={{
              position: 'absolute',
              right: -50,
              top: -10,
              alignItems: 'center'
            }}
            onPress={onPressDismiss}>
            <img src={Constants.Images.close} width="25px" />
          </View>
        </View>
        <Text style={{ color: '#e4c13d' }} className="YesNoRule__Header">
          {`${YesNoRule[2][language]}`}
        </Text>
        <Point title={`${YesNoRule[3][language]}`} />
        <Point title={`${YesNoRule[4][language]}`} />
        <Text style={{ color: '#e4c13d' }} className="YesNoRule__Header">
          {`${YesNoRule[5][language]}`}
        </Text>
        <Point title={`${YesNoRule[6][language]}`} />
        <Point title={`${YesNoRule[7][language]}`} />
        <Point title={`${YesNoRule[8][language]}`} />
        <Text style={headerTitle} className="YesNoRule__BottomHeader">
          {`${YesNoRule[9][language]}`}
        </Text>
      </View>
    </Modal>
  );
};
export default React.memo(YesNoRuleWeb);
